export default __webpack_public_path__ + "static/media/treasury.59bfb1d7.png";